import { stats, heroCover } from "@/mocks/leakHome";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-red-700">
      <div className="absolute inset-0">
        <img
          src={heroCover}
          alt="52爆料 匿名投稿 把想说的发上墙"
          title="52爆料 投稿上墙 吃瓜社区"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-red-950/55 to-red-950/80"></div>
      </div>

      <div className="relative mx-auto flex min-h-[540px] w-full max-w-[1280px] flex-col items-center justify-center px-4 py-16 text-center md:min-h-[620px] md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-semibold text-white backdrop-blur-sm">
          <i className="ri-lock-2-line text-[14px] text-red-300"></i>
          匿名投稿 · 私信渠道 · 帮你把话发上墙
        </span>

        <h1 className="mt-6 max-w-4xl text-4xl font-black leading-tight text-white md:text-6xl">
          有些话憋着难受，
          <br className="hidden md:block" />
          那就<span className="text-amber-400">投稿</span>让我帮你
          <span className="text-amber-400">发上墙</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-red-100 md:text-lg">
          这里是「52爆料」——新鲜瓜料、内幕消息、想说没处说的心里话。
          想发就投，匿名也保护，我在这头替你稳稳上墙。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#entry"
            className="group flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-amber-400 px-7 py-3.5 text-base font-bold text-red-950 shadow-lg shadow-red-950/20 transition hover:bg-amber-300"
          >
            <i className="ri-send-plane-fill text-lg transition group-hover:translate-x-1"></i>
            立刻投稿上墙
          </a>
          <a
            href="#feed"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-base font-bold text-white backdrop-blur-sm transition hover:bg-white/20"
          >
            <i className="ri-eye-line text-lg"></i>
            先看看新鲜瓜
          </a>
        </div>

        <div className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-3 md:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-white/15 bg-white/10 px-4 py-4 backdrop-blur-sm"
            >
              <p className="text-2xl font-black text-white">{s.value}</p>
              <p className="mt-1 text-xs font-medium text-red-200">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}